import { useState, useEffect } from 'react';
import { IApiContentResponseModel } from '@/services/platform/api/model';
import { getContentById } from './index';

export function useConsentItems(ids: string[], locale?: string) {
  const [data, setData] = useState<IApiContentResponseModel[] | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const key = ids.join(',');

  useEffect(() => {
    if (!key) return;

    let cancelled = false;
    setIsLoading(true);

    Promise.all(ids.map(id => getContentById(id, locale)))
      .then(results => {
        if (cancelled) return;
        const items = results.filter((r): r is IApiContentResponseModel => r !== undefined);
        setData(items);
      })
      .catch(err => {
        if (!cancelled) console.warn('[useConsentItems] error:', err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [key, locale]);

  return { data, isLoading };
}
